<template>
    <!-- Root element of PhotoSwipe. Must have class pswp. -->
    <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

        <!-- Background of PhotoSwipe.
            It's a separate element as animating opacity is faster than rgba(). -->
        <div class="pswp__bg"></div>

        <!-- Slides wrapper with overflow:hidden. -->
        <div class="pswp__scroll-wrap">

            <!-- Container that holds slides.
                PhotoSwipe keeps only 3 of them in the DOM to save memory.
                Don't modify these 3 pswp__item elements, data is added later on. -->
            <div class="pswp__container">
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
            </div>

            <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
            <div class="pswp__ui pswp__ui--hidden">

                <div class="pswp__top-bar">

                    <!--  Controls are self-explanatory. Order can be changed. -->

                    <div class="pswp__counter"></div>

                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                    <button class="pswp__button pswp__button--share" title="Share"></button>

                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                    <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                    <!-- element will get class pswp__preloader--active when preloader is running -->
                    <div class="pswp__preloader">
                        <div class="pswp__preloader__icn">
                        <div class="pswp__preloader__cut">
                            <div class="pswp__preloader__donut"></div>
                        </div>
                        </div>
                    </div>
                </div>

                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                    <div class="pswp__share-tooltip"></div>
                </div>

                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
                </button>

                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
                </button>

                <div class="pswp__caption">
                    <div class="pswp__caption__center"></div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'

export default {
    data () {
        return {
            images: [],
            pswp: null
        }
    },

    props: {
        galleryClass: {
            type: String,
            required: true
        },

        options: {
            type: Object,
            default () {
                return {
                    history: false,
                    shareEl: false,
                    index: 0
                }
            }
        }
    },

    mounted () {
        this.init()
    },

    methods: {
        init () {
            this.images = []

            let galElm = document.querySelectorAll('.pswp')[0].parentElement.getElementsByClassName(this.galleryClass)[0]
            if (galElm) {
                let imageLinks = galElm.getElementsByTagName('a')

                for (let i = 0; i < imageLinks.length; i++) {
                    let imageLink = imageLinks[i]
                    let image = imageLink.children[0]
                    this.images.push({
                        src: image.getAttribute('data-original-src'),
                        thumbnail: image.getAttribute('src'),
                        w: image.getAttribute('data-original-src-width'),
                        h: image.getAttribute('data-original-src-height')
                    })

                    imageLink.setAttribute('data-pswp-uid', i);
                    imageLink.onclick = this.thumbnailClicked
                }
            }
        },

        closest (el, fn) {
            return el && (fn(el) ? el : this.closest(el.parentNode, fn))
        },

        thumbnailClicked (e) {
            e = e || window.event
            e.preventDefault ? e.preventDefault() : e.returnValue = false

            let eTarget = e.target || e.srcElement

            let clickedItem = this.closest(eTarget, (el) => {
                return (el.tagName && el.tagName.toUpperCase() === 'A')
            })

            if (!clickedItem) {
                return
            }

            let index = clickedItem.getAttribute('data-pswp-uid')

            if (index >= 0) {
                this.openPhotoSwipe(index)
            }

            return false
        },

        openPhotoSwipe (index) {
            index = parseInt(index)
            this.options.index = index
            let pswpElement = document.querySelectorAll('.pswp')[0]
            this.pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, this.images, this.options)
            this.pswp.init()
            this.pswp.listen('afterChange', () => {
                this.$emit('input', this.pswp.getCurrentIndex())
            })
            this.pswp.listen('close', () => {
                this.$emit('input', null)
            })

            this.$emit('input', index)
        }
    }
}
</script>
